import * as candidateDetailsActionFunctions from './candidate_details_actions';
import * as documentActionFunctions from './document_actions';
import * as layoutActionFunctions from './layout_actions';
import * as notesActionFunctions from './notes_actions';
import * as activityFeedActionFunctions from './activity_feed_actions';
import * as offerActionFunctions from './offer_actions';
import * as statusActionFunctions from './status_actions';
import * as allJobsAndApplicationsActionFunctions from './all_jobs_and_applications_actions';
import * as interviewReminderActionFunctions from './candidate_interview_reminder_actions';
import * as agreementActionFunctions from './agreement_actions';
import * as scorecardActionFunctions from './scorecard_actions';

import type { Actions as NotesActions } from './notes_actions';
import type { Actions as CandidateDetailsActions } from './candidate_details_actions';
import type { Actions as ActivityFeedActions } from './activity_feed_actions';
import type { Actions as StatusActions } from './status_actions';
import type { Actions as DocumentActions } from './document_actions';
import type { Actions as OfferActions } from './offer_actions';
import type { Actions as LayoutActions } from './layout_actions';
import type { Actions as InterviewReminderActions } from './candidate_interview_reminder_actions';
import type { Actions as AgreementActions } from './agreement_actions';
import type { Actions as ScorecardActions } from './scorecard_actions';

export type Action =
  | ActivityFeedActions
  | StatusActions
  | DocumentActions
  | LayoutActions
  | OfferActions
  | NotesActions
  | CandidateDetailsActions
  | InterviewReminderActions
  | AgreementActions
  | ScorecardActions;

const allActions = {
  ...candidateDetailsActionFunctions,
  ...documentActionFunctions,
  ...layoutActionFunctions,
  ...activityFeedActionFunctions,
  ...offerActionFunctions,
  ...statusActionFunctions,
  ...notesActionFunctions,
  ...allJobsAndApplicationsActionFunctions,
  ...interviewReminderActionFunctions,
  ...agreementActionFunctions,
  ...scorecardActionFunctions,
} as const;

type AllActionsWithDispatch = typeof allActions;
export type ActionFns = {
  // Type errors here mean you exported something other than a type or an action function
  [k in keyof AllActionsWithDispatch]: ReturnType<AllActionsWithDispatch[k]>;
};

export default allActions;
